import Button from '@atlaskit/button';
import Textfield from '@atlaskit/textfield';
import { Field } from '@atlaskit/form';
import Modal, {
  ModalTransition,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from '@atlaskit/modal-dialog';
import t from 'modules/i18n/intl';
import React, { useEffect, useState } from 'react';
import { messages } from 'modules/mac/messages';
import { FormattedMessage } from 'react-intl';
import {
  StyledModalFieldsWrapper,
  StyledModalHeaderWithBorder,
  StyledModalInputWrapper,
  StyledModalWrapper,
} from './StyledComponents';
import { fetchExternal } from 'modules/mac/duck/actions/contact';
import { useDispatch, useSelector } from 'react-redux';
import { selectExternal } from 'modules/mac/duck/selectors';
import { addNewContactToAccount } from 'modules/mac/duck/actions/accounts';

export const AddContactModal = ({ isOpen, closeModal, newContact, accountId, newContactType }) => {
  const dispatch = useDispatch();
  const externalResponse = useSelector(selectExternal);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  useEffect(() => {
    setFirstName('');
    setLastName('');
  }, [isOpen]);

  useEffect(() => {
    if (externalResponse) {
      dispatch(
        addNewContactToAccount(accountId, externalResponse?.contactDetails?.id, newContactType),
      );
    }
  }, [externalResponse]);

  const onClickSaveContact = () => {
    if (firstName) {
      const contactDetailsData = {
        contactDetails: {
          firstName,
          lastName,
          email: newContact,
        },
      };
      dispatch(fetchExternal(contactDetailsData));
    }
    closeModal();
  };

  return (
    <>
      <ModalTransition>
        {isOpen && (
          <Modal autoFocus onClose={closeModal}>
            <StyledModalHeaderWithBorder>
              <ModalHeader>
                <ModalTitle>
                  <FormattedMessage {...messages.addNewContact} />
                </ModalTitle>
              </ModalHeader>
            </StyledModalHeaderWithBorder>
            <StyledModalWrapper>
              <ModalBody>
                <FormattedMessage {...messages.notSignedUpContact} />
                <StyledModalFieldsWrapper>
                  <StyledModalInputWrapper>
                    <Field label={t('checkout.contact.firstname')} name="first-name" isRequired>
                      {({ fieldProps }: any) => (
                        <Textfield
                          {...fieldProps}
                          type="text"
                          value={firstName}
                          maxLength={50}
                          onChange={(e) => setFirstName(e.target.value)}
                          data-testid="contact-firstname"
                        />
                      )}
                    </Field>
                  </StyledModalInputWrapper>
                  <StyledModalInputWrapper>
                    <Field label={t('checkout.contact.lastname')} name="contact-lastname">
                      {({ fieldProps }: any) => (
                        <Textfield
                          {...fieldProps}
                          value={lastName}
                          type="text"
                          maxLength={50}
                          onChange={(e) => setLastName(e.target.value)}
                          data-testid="contact-lastname"
                        />
                      )}
                    </Field>
                  </StyledModalInputWrapper>
                  <StyledModalInputWrapper>
                    <Field label={t('mac.licenses.new.contact.email')} name="email">
                      {({ fieldProps }: any) => (
                        <Textfield
                          {...fieldProps}
                          type="text"
                          data-testid="contact-email"
                          value={newContact}
                          isDisabled
                        />
                      )}
                    </Field>
                  </StyledModalInputWrapper>
                </StyledModalFieldsWrapper>
              </ModalBody>
            </StyledModalWrapper>
            <ModalFooter>
              <Button appearance="subtle" onClick={closeModal}>
                <FormattedMessage {...messages.addNewContactModalCancel} />
              </Button>
              <Button appearance="primary" onClick={onClickSaveContact}>
                <FormattedMessage {...messages.addNewContactModalSave} />
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
    </>
  );
};
